export const TYPES_OPTIONS = [
  { label: "Integer", value: "INT" },
  { label: "Double", value: "DOUBLE" },
  { label: "Float", value: "FLOAT" },
  { label: "Long", value: "LONG" },
  { label: "Short", value: "SHORT" },
  { label: "Number", value: "NUMBER" },
  { label: "Character Sequence", value: "CHAR_SEQUENCE" },
  { label: "Byte", value: "BYTE" },
  { label: "Big Decimal", value: "BIG_DECIMAL" },
  { label: "Big Integer", value: "BIG_INT" },
  { label: "Boolean", value: "BOOLEAN" },
  { label: "DateTime", value: "DATETIME" },
  { label: "Time", value: "TIME" },
  { label: "Date", value: "DATE" },
  { label: "String", value: "STRING" },
  { label: "Object", value: "OBJECT" },
  { label: "Collection Object", value: "COLLECTION_OBJECT" },
  { label: "Password", value: "PASSWORD" },
  { label: "Email", value: "EMAIL" },
  { label: "ENUM", value: "ENUM" },
  { label: "File Url", value: "FILE_URL" },
  { label: "Map", value: "MAP" },
  { label: "Set", value: "SET" },
  { label: "UUID", value: "UUID" },
  { label: "Response Data Type", value: "RESPONSE_DATA_TYPE" },
];

export const TABLE_ATTRIBUTE_TYPES = {
  INT: "INT",
  DOUBLE: "DOUBLE",
  FLOAT: "FLOAT",
  LONG: "LONG",
  SHORT: "SHORT",
  NUMBER: "NUMBER",
  CHAR_SEQUENCE: "CHAR_SEQUENCE",
  BYTE: "BYTE",
  BIG_DECIMAL: "BIG_DECIMAL",
  BIG_INT: "BIG_INT",
  BOOLEAN: "BOOLEAN",
  DATETIME: "DATETIME",
  TIME: "TIME",
  DATE: "DATE",
  STRING: "STRING",
  OBJECT: "OBJECT",
  COLLECTION_OBJECT: "COLLECTION_OBJECT",
  PASSWORD: "PASSWORD",
  EMAIL: "EMAIL",
  ENUM: "ENUM",
  FILE_URL: "FILE_URL",
  MAP: "MAP",
  SET: "SET",
  UUID: "UUID"
};

export const TYPES = {
  STRING: "text",
  UUID: "text",
  DATE: "text",
  TIME: "text",
  DATETIME: "text",
  FILE_URL: "text",

  INT: "number",
  DOUBLE: "number",
  LONG: "number",

  BOOLEAN: "radio",

  OBJECT: "object",
  JSON_LIST: "textarea",

  ENUM: "select",
  COLLECTION_OBJECT: "select",
};

export const TEXT_TYPES = [
  "STRING",
  "UUID",
  "DATE",
  "TIME",
  "DATETIME",
  "FILE_URL",
];

export const NUMBER_TYPES = ["INT", "DOUBLE", "LONG"];

export const RADIO_TYPES = ["BOOLEAN"];

export const TEXTAREA_TYPES = ["JSON_LIST"];

export const SELECT_TYPES = ["ENUM", "COLLECTION_OBJECT"];
